import React, { useEffect, useState } from 'react';
import { Card, Form, Button, Row, Col, DatePicker } from 'antd';
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage';
import BaseListing from 'src/BaseListings';
import { SOURCE_TYPE_NAMES, STATUS_NAME, VOUCHER_STATUS_DROPDOWN_OPTIONS } from 'src/models/vouchers';
import WidgetProjectSelector from 'src/widgets/Selectors/WidgetProjectSelector';
import { wtApiCall } from 'src/helpers/commons/ApiWrapper';
import WidgetBranchSelector from 'src/widgets/Selectors/WidgetBranchSelector'
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications';
import { wtFormatMoney } from 'src/helpers/commons/utils';
import WidgetAccountsSelectorVirtualized from 'src/widgets/Selectors/WidgetAccountsSelectorVirtualized';
import WidgetProjectMultiSelector from 'src/widgets/Multi-Selectors/WidgetProjectMultiSelector';

const ProjectDetailReport = () => {
    const Base = new BaseListing('project_detail_report')
    const [isLoading, setIsLoading] = useState(false)
    const [form] = Form.useForm();

    const [accounts, setAccounts] = useState([])
    const [projects, setProjects] = useState([])

    const [accountId, setAccountId] = useState()
    const [accountName, setAccountName] = useState('')
    const [selectedProjects, setSelectedProjects] = useState([])

    const [branchId, setBranchId] = useState(0)
    const [branchName, setBranchName] = useState('')

    const companyName = wtGetFromLocalStorage("company_name");
    const branches = wtGetFromLocalStorage("branches");
    const [dateRange, setDateRange] = useState([]); // to hold the date range
    const [fromDate, setFromDate] = useState(null); // to hold the fromDate
    const [toDate, setToDate] = useState(null); // to hold the toDate


    const changeValues = (key, val, label) => {

        if (key === 'branch_id') {
            setBranchId(val.value)
            setBranchName(val.label)
        }
        if (key === 'account_id') {
            setAccountId(val)
            if (val === undefined) {
                setAccountName('');
            }
            else {
                setAccountName(label[0])
            }
        }
        if (key === 'date_range') {
            setDateRange(val);
        }
    }

    useEffect(() => {
        Base.dropdownData('accounts,projects', { ignore_last_level: false, enable_all_levels: true }, [setAccounts, setProjects], 1);
    }, []);

    const getReportData = () => {
        if (dateRange.length < 2) {
            lzNotifyErrorMessageFromResult("Please select date range");
            return;
        }
        const fromDate = dateRange[0];
        const toDate = dateRange[1];

        setIsLoading(true);
        wtApiCall(
            'reports/project_detail_report',
            {
                branch_id: branchId,
                from_date: fromDate.format('YYYY-MM-DD'),
                to_date: toDate.format('YYYY-MM-DD'),
                account_id: accountId,
                project_ids: JSON.stringify(selectedProjects),
            },
            'get',
            (response) => {

                //set data
                if (response !== null) {
                    if (response.data !== null) {
                        const summaryPdfPath = response.data?.summary_pdf_path;
                        const detailPdfPath = response.data?.detail_pdf_path;
                        if (summaryPdfPath && detailPdfPath) {
                            const downloadFile = (url) => {
                                const link = document.createElement('a');
                                link.href = url;
                                link.download = url.split('/').pop(); // Optional: sets proper filename
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            };

                            // Download one after another
                            setTimeout(() => downloadFile(summaryPdfPath), 500);
                            setTimeout(() => downloadFile(detailPdfPath), 1500);
                        } else {
                            lzNotifyErrorMessageFromResult("No PDF found in response");
                        }
                    }
                }

                setIsLoading(false);
            },
            (error) => {
                lzNotifyErrorMessageFromResult(error);
                setIsLoading(false);
            },
        );

    };


    return (
        <div className='container-fluid' style={{
            padding: "1em", backgroundColor: "white", minHeight: "100vh", fontFamily: "Helvetica",
        }}>
            <Form
                layout={'vertical'}
                form={form}
                onFinish={getReportData}
                style={{ maxWidth: "100%", margin: '0 auto' }}
            >
                <Card title={<span style={{ fontSize: '22px', marginLeft: "40%" }}>{companyName + " Project Detail Report"}</span>} style={{ width: "100%" }}>

                    <Row gutter={[24, 24]}>
                        <Col xs={15} sm={10} md={5}>
                            <label>Date Range: *</label>
                            <DatePicker.RangePicker
                                onChange={(value) => {
                                    setDateRange(value); // Update the whole date range
                                    if (value && value.length === 2) {
                                        setFromDate(value[0].format('YYYY-MM-DD')); // Extract fromDate
                                        setToDate(value[1].format('YYYY-MM-DD')); // Extract toDate
                                    }
                                }}
                                style={{ width: '100%', height: 35 }}
                                value={dateRange}
                            />

                        </Col>
                        <Col xs={20} sm={16} md={11}>
                            <label className='account_dropdown_label_class'>Account: *</label>
                            <WidgetAccountsSelectorVirtualized
                                data={accounts}
                                value={accountId}
                                displayValue={accountName}
                                height={35}
                                onChange={(value, title) => changeValues('account_id', value, title)}
                                reloadDropdownData={() => Base.dropdownData('accounts', {}, [setAccounts], 1)}
                            />
                        </Col>

                        <Col xs={15} sm={10} md={5}>
                            <label>Project: </label>
                            <WidgetProjectMultiSelector
                                Projects={projects}
                                value={selectedProjects}
                                onChange={(values) => setSelectedProjects(values)}
                            />
                        </Col>

                        <Col xs={15} sm={10} md={4}>
                            <label>Branch:</label>
                            <WidgetBranchSelector
                                value={branchId}
                                displayValue={branchName}
                                branches={branches}
                                placeholder="Select Branch"
                                onChange={(values) => changeValues('branch_id', values)}
                                showCloudIcon={false}
                            />

                        </Col>

                        <Col xs={12} sm={8} md={5}>
                            <Button style={{ marginTop: 30, marginRight: 5 }} type="primary" htmlType="submit" disabled={isLoading ? true : false}>Search</Button>
                        </Col>


                    </Row>
                </Card>
            </Form>
        </div >
    );
};

export default ProjectDetailReport;
